import select2 from '../shared/select2';
var $ = window.jQuery;

export default {
  loaded() {
    select2();

    $(document).on('facetwp-loaded', function() {
      select2();
   });
  }
}
